import { afterRender, ChangeDetectorRef, Component, EventEmitter } from '@angular/core';
import { SettingsService, Themes } from '../../services/settings.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-display-settings',
  templateUrl: './display-settings.component.html',
  styleUrls: ['./display-settings.component.scss'],
})
export class DisplaySettingsComponent {
  public manualRefreshEmitter = new EventEmitter<void>();

  public fontSize$: Observable<number>;
  public fontWeight$: Observable<number>;
  public viewportWidth$: Observable<number>;
  public darkMode$: Observable<boolean>;
  public themes: string[];
  public currentTheme: Themes;
  public themeList = Themes;
  public sliderOptions: Options = {
    floor: 0,
    ceil: 125,
    animate: false,
    showTicks: true,
    showTicksValues: false,
    step: 25,
    tickStep: 25,
  };
  public fontWeightSliderOptions: Options = {
    floor: 100,
    ceil: 700,
    animate: false,
    showTicks: true,
    showTicksValues: false,
    step: 300,
    tickStep: 300,
  };
  constructor(
    private settingsService: SettingsService,
    public dialogRef: MatDialogRef<DisplaySettingsComponent>,
    private cdr: ChangeDetectorRef
  ) {
    this.settingsService.theme$
      .subscribe((x: Themes) => {
        this.currentTheme = x;
      })
      .unsubscribe();
    this.fontSize$ = this.settingsService.fontSize$;
    this.fontWeight$ = this.settingsService.fontWeight$;
    this.themes = this.settingsService.getAvailableThemes();
    this.viewportWidth$ = this.settingsService.viewportWidth$;
    this.darkMode$ = this.settingsService.darkMode$;

    afterRender(() => {
      this.manualRefreshEmitter.emit();
    });
  }

  changeFontSize(size: number) {
    this.settingsService.changeFontSize(size);
  }

  changeFontWeight(weight: number) {
    this.settingsService.changeFontWeight(weight);
  }

  changeTheme() {
    this.settingsService.changeTheme(this.currentTheme);
  }

  changeViewportWidth(width: number) {
    this.sliderOptions = {
      ...this.sliderOptions,
    };
    this.settingsService.changeViewportWidth(width);
  }

  toggleDarkMode() {
    this.settingsService.toggleDarkMode();
  }

}
